import React from "react";
import styles from "./AddressBox.module.scss";
import useHover from "../../../utilities/useHover";
import THEME from "../../../state/theme";

export default ({ icon, title, text1, text2 }) => {
  const [ref, isHover] = useHover();
  return (
    <div>
      <div
        ref={ref}
        className={styles.address_box}

      >
        <i className={icon}style={{color: THEME.color}}/>
        <div>
          <h3>{title}</h3>
          <span >{text1}</span>
          <span >{text2}</span>
          {/* style={{color: isHover? THEME.white_color : THEME.blue_ligth}}*/}
        </div>
      </div>
    </div>
  );
};
